import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { AttachDocumentLink } from "@/Common/Components/IconControls/AttachDocumentLink";
import { AttachedDocumentList } from "@/Common/Components/IconControls/AttachedDocumentList";
import { FileSelectionHelper } from "@/Common/Helpers/FileSelectionHelper";
import { FileSelectionContainerType } from "@/Common/Models/FileSelection/FileSelectionContainerType";
import { Person } from "@/Common/Models/Person/Person";
import { FileSelectionContainer } from "@/ExportableFile/Components/FileSelection/FileSelectionContainer";
import { ExportableFileDisplayOption, ExportableFileModel } from "@/ExportableFile/Models/ExportableFileTableItem";

interface IAttachDocumentToRequestComponentProps {
    onAttachmentChange: (files: ExportableFileModel[]) => void;
    removeAttachmentFromList: (id: number) => void;
    selectedAttachments: ExportableFileModel[];
    patient: Person;
}

class AttachDocumentToRequestComponentState {
    public currentFile: ExportableFileModel;
    public isOpenAttachmentPopup: boolean;
}

class AttachDocumentToRequestComponent extends BaseReactComponent<IAttachDocumentToRequestComponentProps, AttachDocumentToRequestComponentState> {
    public constructor(props: IAttachDocumentToRequestComponentProps) {
        super(props);
        this.state = {
            currentFile: null,
            isOpenAttachmentPopup: false
        };
    }

    public render(): JSX.Element {
        return (
            <div>
                <AttachDocumentLink onClick={() => this.mutateState(s => s.isOpenAttachmentPopup = true)} />
                {this.state.isOpenAttachmentPopup && (
                    <FileSelectionContainer
                        patient={this.props.patient}
                        title={cacheStore.GetString("AttachFilesLabel")}
                        type={FileSelectionContainerType.Attachment}
                        onClose={() => this.mutateState(s => s.isOpenAttachmentPopup = false)}
                        onPrintOrAttachClicked={selectedFiles => {
                            this.mutateState(s => s.isOpenAttachmentPopup = false);
                            this.props.onAttachmentChange(this.props.selectedAttachments.concat(selectedFiles
                                .filter(p => this.props.selectedAttachments.all(a => !p.isEquivalent(a.Model) && a.Model.InternalId !== p.InternalId))
                                .map(p => p.toExportableFileModel(ExportableFileDisplayOption.NAME))
                            ));
                        }}
                        popupStyle={{ position: "fixed" }}
                    />
                )}
                <div>
                    {this.props.selectedAttachments?.length > 0 && (
                        <AttachedDocumentList
                            selectedAttachments={this.props.selectedAttachments}
                            removeAttachmentFromList={p => this.props.removeAttachmentFromList(p)}
                            resolveDescription={p => this.resolveDescription(p)}
                        />
                    )}
                </div>
            </div>
        );
    }

    public renderAttachmentPreview(attachedObj: ExportableFileModel): void {
        if (!attachedObj)
            throw new Error("attachedObj should not be null.");
        attachedObj.Model.openInNewWindow();
        this.mutateState(s => s.currentFile = null);
    }

    private resolveDescription(attachment: ExportableFileModel): string {
        if (!IsNullOrWhiteSpace(attachment.displayDescription))
            return attachment.displayDescription;

        return FileSelectionHelper.determineTypeName(attachment.Model.fileType);
    }
}

export { AttachDocumentToRequestComponent };
